import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import styles from './Controls3dTooltip.module.scss';

export const TouchControls3dTooltip = () => {
    const { t } = useTranslation();
    return (
        <>
            <Grid align='center'>
                <Icon size='small' type='controls-pinch-to-zoom' className={styles.icon} />
                <p className={styles.text}>{t('controls.pinch_to_zoom')}</p>
            </Grid>

            <div className={styles.separator} />

            <Grid align='center'>
                <Icon size='small' type='controls-drag-to-rotate' className={styles.icon} />
                <p className={styles.text}>{t('controls.drag_to_rotate')}</p>
            </Grid>
        </>
    );
};